import { Link } from 'react-router-dom';
import { EmptyState } from '@/components/ui';
import { AuthLayout } from '@/layouts/AuthLayout';
import type { Permission } from '@/auth/permissions';
import { useT } from '@/i18n/context';

export function ForbiddenPage({ permission, noContext }: { permission?: Permission; noContext?: boolean }) {
  const t = useT();
  if (noContext) {
    return (
      <EmptyState
        title={t('status.noContext.title')}
        text={t('status.noContext.text')}
        action={<Link to="/me/professional" className="btn btn--secondary">{t('status.noContext.action')}</Link>}
      />
    );
  }
  return (
    <EmptyState
      title={t('status.forbidden.title')}
      text={permission ? t('status.forbidden.withPermission', { permission }) : t('status.forbidden.plain')}
      action={<Link to="/" className="btn btn--secondary">{t('status.forbidden.action')}</Link>}
    />
  );
}

export function NotFoundPage() {
  const t = useT();
  return (
    <AuthLayout title={t('status.notFound.title')} aside={t('status.notFound.aside')}>
      <p className="muted">{t('status.notFound.text')}</p>
      <Link to="/" className="btn btn--primary btn--block">{t('status.notFound.action')}</Link>
    </AuthLayout>
  );
}
